<script>
  import { _ } from 'svelte-i18n'
	import { previews_are_google_fonts, previews_are_highlighted, previews_nav_filters } from '../stores';
  import ClearHighlightButton from './ClearHighlightButton.svelte'
  import FilterSelectedToggle from './PreviewsFilterSelectedToggle.svelte'
  export let selected_count
	export let previews_are_dense
</script>

<div class="stickyWrapper">
	<div 
	class="stickyButtons" 
	class:previews_are_dense 
	class:further-up={($previews_nav_filters.tagged || $previews_are_google_fonts) && !$previews_nav_filters.selected}>
    <div>
      {#if $previews_are_highlighted}
        <ClearHighlightButton />
			{/if}
			{#if selected_count > 0}
        <FilterSelectedToggle/>
      {/if}
    </div>
  </div>
</div>

<style>
	.stickyWrapper {
		position: absolute;
		width: calc(100% - 2rem);
		height: 100%;
	}
	.stickyButtons {
		position: sticky;
		z-index: 2;
		top: 12rem;
		right: 2rem;
	}
	.stickyButtons.previews_are_dense {
		margin-top: -0.5rem;
    margin-right: 0.5rem;
	}
	.stickyButtons.further-up {
		top: 16rem;
	}
	.stickyButtons > div {
		float: right;
		margin-top: -11rem;
		margin-right: 1rem;
	}
	.stickyButtons.further-up > div {
		margin-top: -15rem;
	}
	.stickyButtons :global(button) {
		margin-left: 1rem;
	}
</style>